const defaultBranding = {
    // type of product - eg, "forms"
    ProductType: "Phone Number Search",
    // menu text to select product search tab - eg, "Forms Search"
    SearchLabel: "Search Phone Number",
    // meta keyword specified in manifest (might not be the same as product type) - eg, "forms"
    MetaSearchKeyword: "phone",
    // example searches on first run - eg, "Taxes, Immigration, US"
    SearchExample: "555-555-0198",
    // eg, "Search form titles or tags"
    AutocompletePlaceholder: "Enter a 10-digit Phone Number",
    // eg, "Search our database for forms by typing in a form query in the search box above."
    IntroLI1: "Reverse Phone Search identifies telephone and cell phone numbers.",
    // eg, "You can also browse our forms database by 'tag' located on the left side menu of the page."
    IntroLI2: "Discover who is calling you, no matter if it is a cell phone, landline, or unpublished number.",
    FirstRunSettings: false,
}

const windowBranding = window.branding || {};

const PRODUCT_SEARCH_PROVIDERS = {
    default: {
        name: "Whitepages",
        id: "default",
        isDefault: true,
        url: "https://www.whitepages.com/phone/{{QUERY}}",
    },
    thatsthem: {
        name: "That's Them",
        id: "thatsthem",
        isDefault: false,
        url: "https://www.thatsthem.com/phone/{{QUERY}}",
    },
    peoplefinders: {
        name: "People Finders",
        id: "peoplefinders",
        isDefault: false,
        url: "https://www.peoplefinders.com/reverse-phone/searchresults?search=Phone&phone={{QUERY}}",
    },
}

const altSearchProvidersUrls = function(query) {
    const altProviders = Object.entries(PRODUCT_SEARCH_PROVIDERS).filter(([key, value]) =>  !value.isDefault);
    return altProviders.map(([key, value]) => {
        return {
            name: value.name,
            url: value.url.replace("{{QUERY}}", query),
        }
    });
}

const DEFAULT_PRODUCT_SEARCH_PROVIDER = PRODUCT_SEARCH_PROVIDERS["default"].id;

function getBranding(){
    return {
        ...defaultBranding,
        ...windowBranding,
    }
}

export {
    getBranding,
    PRODUCT_SEARCH_PROVIDERS,
    altSearchProvidersUrls,
    DEFAULT_PRODUCT_SEARCH_PROVIDER,
}



// WEBPACK FOOTER //
// ./src/branding.js